import { Stack, Tooltip, Typography } from '@mui/material'
import React, { ReactNode } from 'react'
import IconTile from './IconTile'
import { Info } from '@mui/icons-material'

type DetailsTileProps = {
  title: string
  description: ReactNode
  icon: ReactNode
  wrap?: boolean
  info?: boolean
  tooltip?: string
}

const DetailsTile = ({ title, description, icon, wrap = false, info = false, tooltip = '' }: DetailsTileProps) => {
  const wrapStyles = wrap
    ? {}
    : {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    }

  return (
    <Stack direction="row" gap={2}>
      <Stack>
        <IconTile icon={icon} />
      </Stack>

      <Stack direction="column" alignItems="start" width="100%" overflow="hidden">
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography variant="body1" color="text.highEmphasis" fontWeight={700} sx={{ width: '100%', ...wrapStyles }}>
            {title}
          </Typography>
          {info && (
            <Tooltip title={tooltip}>
              <Info sx={{ fontSize: 16 }} />
            </Tooltip>
          )}
        </Stack>
        <Typography variant="body1" color="text.base" sx={{ width: '100%', ...wrapStyles }}>
          {description}
        </Typography>
      </Stack>
    </Stack>
  )
}

export default DetailsTile
